import {ysAudit as apis} from '@/api/finance'
// 应收审核
// 表头：（发货日期、线路、车号、运费、油卡、信息费、
// 调度员、货主、结款状态、结算金额、收款人、发起人、发起时间）
const listConfig = [
    {title: '发货日期', key: 'deliveryTime'},
    {title: '线路', key: 'road'},
    {title: '车号', key: 'carNo'},
    {title: '运费', key: 'freight'},
    {title: '油卡', key: 'oilCard'},
    {title: '信息费', key: 'messageFee'},
    {title: '调度员', key: 'yardman'},
    {title: '货主', key: 'shipper'},
    {
        title: '结算类型', key: 'raType',
        showData: {
            '1': '全部结算',
            '2': '部分结算',
        }
    },
    {title: '结算金额', key: 'raMoney'},

    {title: '收款人', key: 'raReceiver'},
    {title: '发起人', key: 'raProposerName'},
    {title: '发起时间', key: 'raTime'},
]

function createSearch() {
    return [
        {title: '车号', value: '', key: 'carNo', type: 'input'},
        {title: '线路', value: '', key: 'road', type: 'input'},
        {title: '发货日期', value: [], key: 'deliveryTime', type: 'date2'},
    ]
}


const notRequired = true;

function createReject() {
    return [
        {column: '驳 回'},
        {title: '审批备注', value: '', key: 'remark', type: 'textarea', span: 24, notRequired},
    ]
}

const detailConfig = [
    {column: '派车信息'},
    {title: '发车时间', key: 'deliveryTime', value: ''},
    {title: '货物名称', value: '', key: 'cargoName'},
    {title: '线路', value: '', key: 'road'},
    {title: '车号', value: '', key: 'carNo'},
    {title: '司机', value: '', key: 'driverName'},
    {title: '司机电话', value: '', key: 'driverTel'},
    {title: '运费', value: '', key: 'freight'},
    {title: '油卡', value: '', key: 'oilCard'},
    {title: '信息费', value: '', key: 'messageFee'},
    {title: '调度员', value: '', key: 'yardman'},
    {title: '货主', value: '', key: 'shipper'},
    {title: '货主电话', value: '', key: 'shipperTel'},
    {column: '结 算'},
    {
        title: '结算状态', value: '', key: 'statusJie',
        transform(data) {
            const _date = {
                '1': '已结算',
                '2': '未结算',
                '3': '部分结算',
                '4': '审核中',
            }
            return _date[data.statusJie]
        }
    },
    {title: '结算时间', value: '', key: 'jieTime'},
    {title: '结算金额', value: '', key: 'jieMoney'},
    {title: '收款人', value: '', key: 'receiver'},
    {
        title: '油卡结算', value: '', key: 'oilOver',
        transform(data) {
            const _date = {
                '1': '已结算',
                '2': '未结算'
            }
            return _date[data.oilOver]
        }
    },
    {column: '审 核'},
    {
        title: '油卡结算', value: '', key: 'raOilOver',
        transform(data) {
            const _date = {
                '1': '已结算',
                '2': '未结算'
            }
            return _date[data.raOilOver]
        }
    },
    {title: '结算类型', value: '', key: 'raType',
        transform(data) {
            const _date = {
                '1': '全部结算',
                '2': '部分结算'
            }
            return _date[data.raType]
        }},
    {title: '发起人姓名', value: '', key: 'raProposerName'},
    {title: '发起时间', value: '', key: 'raTime'},
    {title: '结算审核金额', value: '', key: 'raMoney'},
    {title: '结算收款人', value: '', key: 'raReceiver'},
    {column: '备 注'},
    {
        title: '备注',
        key: 'operation_remark', span: 24, value: '',
        transform(data) {
            return data.remarks
        },
        export_transform(data) {
            return data.remarks.map(item => item.remark).join(';');
        }
    },
    {column: '操作记录 '},
    {
        key: 'operation_record', span: 24, value: '',
        transform(data) {
            return data.logs
        }
    }
]


const getHeaderData = () => {
    const _data = {};
    detailConfig.forEach(item => {
        if (item.export_transform && item.key !== 'operation_record') {
            _data[item.title] = {transform: item.export_transform, key: item.key};
        } else if (item.transform && item.key !== 'operation_record') {
            _data[item.title] = {transform: item.transform, key: item.key};
        } else if (item.key && item.key !== 'operation_record') {
            _data[item.title] = item.key;
        }
    })
    console.log(_data)
    return _data;
}

const btnConfig = [
    {bg: '#19458C', title: '通 过', key: 'submit', role: 'Submit'},
    {bg: '#EA5B24', title: '驳 回', key: 'reject', role: 'Reject'},
    {
        bg: '#EA5B24', title: '导 出', key: 'export', role: 'Export',
        header_data: getHeaderData(listConfig), label: '应收订单审核'
    },
]

export default function config() {
    return {
        detailConfig,
        listConfig,
        btnConfig,
        createSearch,
        createReject,
        apis
    }
}
